"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var context_1 = require("../context");
function defineFilterState(filterKey) {
    return {
        useFilterState: createUseFilterState(filterKey),
        createClientFilter: function (predicateFromFilterState) { return makeClientFilter(filterKey, predicateFromFilterState); },
    };
}
exports.default = defineFilterState;
function createUseFilterState(filterKey) {
    var useFilterStateHook = function () {
        var _a = context_1.useListingContext().filtering, setFilter = _a.setFilter, selection = _a.selection;
        var setFilterValue = React.useCallback(function (value) { return setFilter(filterKey, value); }, [setFilter, filterKey]);
        return React.useMemo(function () { return [selection[filterKey], setFilterValue]; }, [selection[filterKey], setFilterValue]);
    };
    var useValue = function () {
        var _a = __read(useFilterStateHook(), 1), value = _a[0];
        return value;
    };
    return Object.assign(useFilterStateHook, { useValue: useValue });
}
function makeClientFilter(filterKey, predicateFromFilterState) {
    return function (filterValues) {
        var filterState = filterValues[filterKey];
        if (filterState === undefined) {
            return function () { return true; };
        }
        return predicateFromFilterState(filterState);
    };
}
//# sourceMappingURL=defineFilterState.js.map